import { render, staticRenderFns } from "./PmtaServers.vue?vue&type=template&id=fc7069d8&scoped=true"
import script from "./PmtaServers.vue?vue&type=script&lang=js"
export * from "./PmtaServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7069d8",
  null
  
)

export default component.exports